/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/CheckoutForm/theme';

export const CheckoutFormTheme = theme;
